import {
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import useSurayForm from "components/request-document/hooks/useSurayForm";
import { getErrorMessage, isError } from "libs/utils/form";
import { React } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";

export default function Survey({ isDraftDocument }) {
  const classes = useStyles();
  const { formik } = useSurayForm();
  const canEdit = useSelector(canEditForm);
  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle title="Survey" subTitle="Survey" />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Survey Requestion
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="survey.isYes"
                              value={formik.values.survey.isYes}
                              checked={Boolean(formik.values.survey.isYes)}
                              onClick={() => {
                                formik.setFieldValue("survey.isYes", true);
                              }}
                            />
                          }
                          label="Yes, I am happy to do it."
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="survey.isYes"
                              value={formik.values.survey.isYes}
                              checked={formik.values.survey.isYes === false}
                              onClick={() => {
                                formik.setFieldValue("survey.isYes", false);
                              }}
                            />
                          }
                          label="No, not now."
                        />
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>

            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Survey
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Shareholding structure</InputLabel>
                      <div className={classes.flexRow}>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8 }}
                          type="number"
                          name="survey.shareholdingThaiPersons"
                          value={formik.values.survey.shareholdingThaiPersons}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError(
                            "survey.shareholdingThaiPersons",
                            formik
                          )}
                          helperText={getErrorMessage(
                            "survey.shareholdingThaiPersons",
                            formik
                          )}
                        />
                        <Typography>% owned by Thai persons</Typography>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8, marginLeft: 8 }}
                          type="number"
                          name="survey.shareholdingForeigners"
                          value={formik.values.survey.shareholdingForeigners}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError(
                            "survey.shareholdingForeigners",
                            formik
                          )}
                          helperText={getErrorMessage(
                            "survey.shareholdingForeigners",
                            formik
                          )}
                        />
                        <Typography>
                          % owned by foreigners or foreign companies
                        </Typography>
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>Number of employees</InputLabel>
                      <div className={classes.flexRow}>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8 }}
                          type="number"
                          name="survey.thaiEmployees"
                          value={formik.values.survey.thaiEmployees}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("survey.thaiEmployees", formik)}
                          helperText={getErrorMessage(
                            "survey.thaiEmployees",
                            formik
                          )}
                        />
                        <Typography>Number of employees</Typography>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8, marginLeft: 8 }}
                          type="number"
                          name="survey.foreignersEmployees"
                          value={formik.values.survey.foreignersEmployees}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("survey.foreignersEmployees", formik)}
                          helperText={getErrorMessage(
                            "survey.foreignersEmployees",
                            formik
                          )}
                        />
                        <Typography>foreigners</Typography>
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>Annual R&D expenditures </InputLabel>
                      <div className={classes.flexRow}>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8 }}
                          type="number"
                          name="survey.annualExpBaht"
                          value={formik.values.survey.annualExpBaht}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("survey.annualExpBaht", formik)}
                          helperText={getErrorMessage(
                            "survey.annualExpBaht",
                            formik
                          )}
                        />
                        <Typography>Baht</Typography>
                        <TextField
                          disabled={
                            formik.values.survey.isYes !== true || !canEdit
                          }
                          className={classes.textField}
                          style={{ marginRight: 8, marginLeft: 8 }}
                          type="number"
                          name="survey.annualExptTotal"
                          value={formik.values.survey.annualExptTotal}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("survey.annualExptTotal", formik)}
                          helperText={getErrorMessage(
                            "survey.annualExptTotal",
                            formik
                          )}
                        />
                        <Typography>% of total sales</Typography>
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Number of employees with master’s degree or above
                      </InputLabel>
                      <TextField
                        disabled={
                          formik.values.survey.isYes !== true || !canEdit
                        }
                        className={classes.textField}
                        style={{ marginRight: 8 }}
                        type="number"
                        name="survey.employeesMaster"
                        value={formik.values.survey.employeesMaster}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("survey.employeesMaster", formik)}
                        helperText={getErrorMessage(
                          "survey.employeesMaster",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Number of employees with a university degree in science
                        and technology
                      </InputLabel>
                      <TextField
                        disabled={
                          formik.values.survey.isYes !== true || !canEdit
                        }
                        className={classes.textField}
                        style={{ marginRight: 8 }}
                        type="number"
                        name="survey.employeesUniversity"
                        value={formik.values.survey.employeesUniversity}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("survey.employeesUniversity", formik)}
                        helperText={getErrorMessage(
                          "survey.employeesUniversity",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          isDisabledNextButton={canEdit && formik.values.survey.isYes === null}
          hideSaveDraft
          hideSubmit={!canEdit || !isDraftDocument}
          nextButtonText="Submit"
        />
      </form>
    </div>
  );
}
